import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScLayoutTopnavigationComponent } from './layouts/sc-layout-topnavigation/sc-layout-topnavigation.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { JobComponent } from './views/job/job.component';


const routes: Routes = [  
  {
    path: '',
    component: ScLayoutTopnavigationComponent,
    children: [      
      {
        path: 'job/:secret',
        component: JobComponent,
        data: { title: 'Ihr Jobangebot', bodyClasses: ['bg-white', 'navbar-transparent', 'job-site'] }
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/404'
  },
  {
    path: '404',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }
